import { Card, Switch } from '@seiue/ui'
import React, { useContext } from 'react'
import styled from 'styled-components'

import { Paper, PaperBlock, paperApi } from 'packages/sdks-next/growp'
import { precisionFormat } from 'packages/utils'

import { EditPaperContext } from '../context'

import { ScoreSetting } from './ScoreSetting'

/**
 * 试卷编辑 - 分数设置卡片
 *
 * @param param - 参数
 * @param param.paper - 试卷相关信息
 * @param param.blocks - 试题块
 * @returns React.ReactNode
 */
export const ScoreSettingCard: React.FC<{
  paper: Paper
  blocks: PaperBlock[]
}> = ({ paper, blocks }) => {
  const { id, showScore } = paper
  const { limitLevel } = useContext(EditPaperContext)
  const { api: updatePaper } = paperApi.useUpdatePaper({
    reload: [paperApi.loadPaper],
  })
  return (
    <Card
      title={
        <RightCardHeader>
          <div>分数设置</div>
          <div>
            <Switch
              disabled={limitLevel > 1}
              size="small"
              checked={!!showScore}
              onChange={async (checked) => {
                await updatePaper({
                  id,
                  payload: {
                    showScore: checked ? 1 : 0,
                  },
                })
              }}
            />
          </div>
        </RightCardHeader>
      }
      type="divided"
      style={{
        width: 240,
        borderRadius: 8,
      }}
      contentStyle={{
        padding: '12px 20px',
        minHeight: '350px',
        maxHeight: `calc(100vh - 152px)`,
        overflow: 'auto',
      }}
    >
      <>
        <StatisticsWrapper $showScore={!!showScore}>
          <div>
            小题总数：<Statistics>{paper.questionCount}</Statistics>
          </div>
          {showScore ? (
            <div>
              满分：
              <Statistics>{precisionFormat(paper.scoreSum)}</Statistics>
            </div>
          ) : null}
        </StatisticsWrapper>
        {showScore ? <ScoreSetting blocks={blocks} /> : null}
      </>
    </Card>
  )
}

const RightCardHeader = styled.div`
  width: 100%;
  height: 48px;
  padding: 20px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > div:first-child {
    font-size: 16px;
    color: ${(props) => props.theme.text._1};
  }
  & > div:last-child {
    font-size: 14px;
    color: ${(props) => props.theme.text._1};
    & > span {
      color: ${(props) => props.theme.brand._1};
    }
  }
`

const StatisticsWrapper = styled.div<{ $showScore: boolean }>`
  width: 100%;
  height: 40px;
  padding: 9px 8px;
  margin-bottom: 12px;
  display: flex;
  justify-content: ${(props) =>
    props.$showScore ? 'space-between' : 'center'};
  align-items: center;
  border-radius: 8px;
  font-size: 14px;
  background-color: ${(props) => props.theme.brand._5};

  & > div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: ${(props) => props.theme.text._1};
  }
`

const Statistics = styled.div`
  color: ${(props) => props.theme.brand._1};
`
